// What came of your covert ops, and of ops done to you (`espionage.ops`,
// `espionage.counter_intel`) — English. Merged in ./messages.ts.

export const gameOpNewsEn = {
  'espionage.news.mine.sabotage.success': 'Your sabotage succeeded.',
  'espionage.news.mine.sabotage.seen': 'Your sabotage failed, and your agent was seen.',
  'espionage.news.mine.sabotage.lost': 'Your sabotage failed, and your agent is lost.',
  'espionage.news.mine.sabotage.quiet': 'Your sabotage failed, and nobody noticed.',
  'espionage.news.mine.assassination.success': 'The royal is dead.',
  'espionage.news.mine.assassination.seen': 'The strike failed, and your assassin was seen.',
  'espionage.news.mine.assassination.lost': 'The strike failed, and your assassin is lost.',
  'espionage.news.mine.assassination.quiet': 'The strike failed, and nobody noticed.',
  'espionage.news.mine.poison.success': 'The supply is fouled.',
  'espionage.news.mine.poison.seen': 'The poisoning failed, and your agent was seen.',
  'espionage.news.mine.poison.lost': 'The poisoning failed, and your agent is lost.',
  'espionage.news.mine.poison.quiet': 'The poisoning failed, and nobody noticed.',
  'espionage.news.mine.intercept.seen': 'The agent slipped away before you could take them.',
  'espionage.news.mine.intercept.lost': 'You caught a foreign agent.',
  'espionage.news.theirs.sabotage.blamed': 'Sabotage in your city. You blame {house}.',
  'espionage.news.theirs.sabotage.unknown': 'Sabotage in your city. Nobody knows whose.',
  'espionage.news.theirs.sabotage.caught': 'A saboteur was caught: {house} sent them.',
  'espionage.news.theirs.assassination.blamed': 'A royal of your house is dead. You blame {house}.',
  'espionage.news.theirs.assassination.unknown':
    'A royal of your house is dead. Nobody knows whose hand.',
  'espionage.news.theirs.assassination.caught': 'An assassin was caught: {house} sent them.',
  'espionage.news.theirs.poison.blamed': 'Your supplies are fouled. You blame {house}.',
  'espionage.news.theirs.poison.unknown': 'Your supplies are fouled. Nobody knows whose hand.',
  'espionage.news.theirs.poison.caught': 'A poisoner was caught: {house} sent them.',
  'espionage.news.theirs.intercept.caught': 'A foreign guard seized your agent.',
  'espionage.news.framed.sabotage': 'A sabotage was blamed on you. You had no part in it.',
  'espionage.news.framed.assassination': 'A killing was blamed on you. You had no part in it.',
  'espionage.news.framed.poison': 'A poisoning was blamed on you. You had no part in it.',
} as const;
